import { useCallback, useEffect, useRef, useState } from 'react';

import { CopyActionButton } from './styledComponents';

interface CopyButtonProps {
  value: string;
  testId: string;
}

type CopyStatus = 'idle' | 'copied' | 'failed';

const RESET_DELAY_MS = 2000;
const LABELS: Record<CopyStatus, string> = {
  idle: 'Copy',
  copied: 'Copied',
  failed: 'Copy failed',
};

export const CopyButton = ({ value, testId }: CopyButtonProps) => {
  const [status, setStatus] = useState<CopyStatus>('idle');
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  const handleCopy = useCallback(async () => {
    let next: CopyStatus = 'copied';
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      next = 'failed';
    }
    setStatus(next);
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => setStatus('idle'), RESET_DELAY_MS);
  }, [value]);

  return (
    <CopyActionButton type="button" onClick={handleCopy} data-testid={testId}>
      {LABELS[status]}
    </CopyActionButton>
  );
};
